<script>
  export default {
    name: "AppDiamonds",
    mounted() {
      const containers = document.querySelectorAll(".container");

      containers.forEach(container => {
        for (let i = 0; i < 12; i++) {
          const diamond = document.createElement("div");
          diamond.classList.add("diamond");
          if (i%2 === 0){
            diamond.classList.add("layer1");
          } else{
            diamond.classList.add("layer2");
          }

          // Positionnement aléatoire dans le conteneur
          diamond.style.left = `${(Math.floor(i/3)*23 + Math.random() * 23)+2}vw`;
          diamond.style.top = `${((i%3)*31 + Math.random() * 31)+ 2}vh`;

          if (Math.random()*9 > 1){
            container.appendChild(diamond);
          } else {
            if (Math.random()*2 > 1){
              container.appendChild(diamond);
              diamond.style.left = `${Math.random() * 100}vw`;
              diamond.style.top = `${Math.random() * 100}vh`;
              container.appendChild(diamond);
            }
          }
        }
      });
    }
  };
</script>

<template>
  <div>
    <div class="container"></div>
    <div class="container"></div>
  </div>
</template>

<style>
  .container{
    width: 98vw;
    height: 99vh;
    position: absolute;
    top: 0;
    left: 0;
    clip-path: inset(0 0 0 0);
  }
  .diamond {
    width: 7px;
    height: 7px;
    background-color: rgba(255, 255, 240, 0.8);
    position: fixed;
    transform: rotate(45deg); /* Transformation en losange */
  }

  /* RESPONSIVE */
  .diamond {
    background-color: rgba(255, 255, 240, 0.5);
  }
</style>